import type { RelativeDateTimeUnit } from 'cadenza/relative-date-time/relative-date-time-unit';

import i18n from './relative-date-time.properties';

/** @see net/disy/cadenza/selector/condition/RelativeDateTime.java */
export interface RelativeDateTime {
  amount: number;
  unit: RelativeDateTimeUnit;
}

export function getRelativeDateTimeLabel ({ unit, amount }: RelativeDateTime) {
  return i18n(`label.<${unit}_${amount}>`);
}
